<template>
    <div>
        <sub-menu-laudos ativo="visao"></sub-menu-laudos>

        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load(false)" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa fa-building fa-fw" :class="filtro.id_unidade_operacao ? 'text-success' : ''" aria-hidden="true"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="filtro.id_unidade_operacao">
                                <option value="">Unidades...</option>
                                <option v-for="(und, iux) in $util.unidades_com_tags(false, true)"
                                    :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col col-12 col-md-3">
                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fas fa-concierge-bell fa-fw" :class="filtro.id_recepcao ? 'text-success' : ''" aria-hidden="true"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="filtro.id_recepcao" :disabled="!filtro.id_unidade_operacao">
                                <option value="">Recepção...</option>
                                <template v-if="filtro.id_unidade_operacao && $util.unidade_operacao(filtro.id_unidade_operacao)">
                                    <option v-for="(rec, irx) in $util.unidade_operacao(filtro.id_unidade_operacao).recepcaos"
                                        :value="rec.id_recepcao" :key="irx">{{ rec.search }}</option>
                                </template>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa fa-calendar-o fa-fw"
                            placeholder="Atendimento" 
                            type="select" 
                            :optionsList="[
                                { id: 'E', search: 'Entrega' }, 
                            ]"
                            optionsData="id" 
                            v-model="filtro.tipo_data" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input
                            placeholder="Selecionar paciente..."
                            icon="fas fa-user fa-fw"
                            type="autocomplete"
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="paciente"
                            :optimized_ac="true" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input icon="fa fa-search fa-fw" v-model="search" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="far fa-credit-card fa-fw"
                            type="select" 
                            optionsMode="aql"
                            optionsData="id_operadora"
                            optionsDisplay="st_operadora"
                            service="operadoras.index"
                            :optionsParm="{ 
                                fatura: true,
                                classes: false,
                                lista: true
                            }"
                            optionsName="operadoras-para-fatura-2"
                            placeholder="Operadoras..."
                            v-model="filtro.id_operadora">
                        </az-input>
                    </div>
                </div>


                <div class="form-row mt-2" v-if="filas && filas.length">
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            optionsMode="aql"
                            service="status_laudos.index"
                            optionsData="id_status_laudo"
                            placeholder="Todos os status..."
                            icon="fa fa-filter fa-fw"
                            v-model="filtro.id_status_laudo" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <template v-if="$store.state.user.medico">
                            <az-input
                                type="checkbox-group"
                                label="Meus Exames"
                                v-model="meus" />
                        </template>
                        <template v-else>
                            <az-input
                                placeholder="Todos os Profissionais..."
                                icon="fas fa-user-md fa-fw"
                                type="select"
                                optionsMode="aql"
                                service="medicos.index"
                                optionsName="medicos-cadastro"
                                :optionsParm="{ ativos: true }"
                                optionsData="id_pessoa"
                                v-model="filtro.id_medico" />
                        </template>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            :type="( filas && filas.length <= 3 ) ? 'button-group' : 'select'"
                            :optionsList="filas.map(item => { return { id: item.id_fila_laudo, search: item.search } })"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtro.id_fila_laudo"
                            :edicao="!$store.state.loading">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input   
                            icon="fa-solid fa-object-group"
                            type="select"
                            placeholder="Status"
                            :optionsList="[
                                { 
                                    id: 'operadora',
                                    search: 'Operadora', 
                                },
                                { 
                                    id: 'plano',
                                    search: 'Operadora/Plano', 
                                },
                                { 
                                    id: 'paciente',
                                    search: 'Paciente', 
                                },
                                { 
                                    id: 'procedimento',
                                    search: 'Procedimento', 
                                },
                                { 
                                    id: 'medico',
                                    search: 'Profissional', 
                                },
                                { 
                                    id: 'unidade',
                                    search: 'Unidade', 
                                },
                            ]"
                            optionsData="id"
                            v-model="filtro.grupo" />
                    </div>

                    <div class="col col-12 col-md-1">
                        <az-input   
                            type="button-group"
                            placeholder="Grupo"
                            :optionsList="[
                                { 
                                    id: '',
                                    search: 'fa-solid fa-draw-square fa-fw', 
                                    icon: true,
                                },
                                { 
                                    id: 'tabela',
                                    search: 'fa fa-table fa-fw', 
                                    icon: true,
                                },
                            ]"
                            optionsData="id"
                            :edicao="!!filtro.grupo"
                            v-model="filtro.tipo_visao" 
                            @input="load()" />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state v-if="!lista || !lista.length"
            :icon="firstLoad ? 'fas fa-notes-medical' : 'fas fa-sync-alt'"
            :msg="firstLoad ? 'Nenhuma item encontrado.' : 'Clique no ícone para realizar a busca.'"
            :action="firstLoad ? '' : 'Buscar'"
            :method="load"></az-empty-state> 

        <template v-else>

            <template v-if="tipo_visao_buscada == 'tabela'">
                <table class="table table-hover bg-white">
                    <thead>
                        <tr>
                            <th>Descrição</th>
                            <th class="text-right" v-for="(item_status, isx) in lista_status_buscados" :key="isx">
                                {{ item_status.st_status_laudo }}
                            </th>
                            <th class="text-right">Total</th>
                            <th class="text-right">Atrasados</th>
                        </tr>
                    </thead>
                    <tbody v-for="(items, grupo, icx) in lista_agrupada" :key="icx">
                        <tr :class="totalizar(items, 'qtde') == totalizar(items, 'prontos') ? 'table-success' : ''">
                            <td>
                                {{ grupo }}
                            </td>
                            <td class="text-right" v-for="(item_status, isx) in lista_status_buscados" :key="isx">
                                {{ totalizar(items.filter(item => item.id_status_laudo == item_status.id_status_laudo), 'qtde') }}
                            </td>
                            <td class="text-right">
                                {{ totalizar(items, 'qtde') }}
                            </td>
                            <td class="text-right">
                                {{ totalizar(items, 'atrasados') }}
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Total</th>
                            <td class="text-right" v-for="(item_status, isx) in lista_status_buscados" :key="isx">
                                {{ totalizar(lista.filter(item => item.id_status_laudo == item_status.id_status_laudo), 'qtde') }}
                            </td>
                            <td class="text-right">
                                {{ totalizar(lista, 'qtde') }}
                            </td>
                            <td class="text-right">
                                {{ totalizar(lista, 'atrasados') }}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </template>
                
            <template v-else>

                <div class="form-row">
                    <div class="col col-12 col-md-3 mb-2" v-for="(item, icx) in lista" :key="icx">
                        <div class="card h-100 mb-0 dashcard">
                            <div class="card-body d-flex justify-content-between py-2" :class="'alert-' + item.st_color">
                                <div>
                                    <div class="lead">
                                        <a href="#" @click.prevent="filtrar_status(contador)" class="card-link">
                                            {{ item.st_status_laudo }}
                                        </a>
                                    </div>
                                    <div class="small font-italic" v-if="item.prontos > 0">
                                        Prontos: {{ item.prontos }}
                                    </div>
                                    <div class="small font-italic" v-if="item.atrasados > 0">
                                        Atrasados: {{ item.atrasados }}
                                    </div>
                                    <div class="small font-italic" v-if="item.tat !== null && item.tat >= 0">
                                        TAT: {{ $util.formatMoeda(item.tat, 1) }}d
                                    </div>
                                </div>
                                <div class="text-right">
                                    <span class="display-4">
                                        {{ item.qtde }}
                                    </span>
                                    <div class="small text-muted">
                                        {{ Math.round( ( item.qtde / totalizar(lista, 'qtde') ) * 100 ) }}%
                                    </div>
                                    <div v-if="false">
                                        <span class="badge badge-light" title="Pacientes">
                                            P: {{ contador.qt_pacientes }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12 col-md-3 mb-2" v-if="lista && lista.length > 1">
                        <div class="card h-100 mb-0 dashcard">
                            <div class="card-body d-flex bg-dark text-white justify-content-between py-2">
                                <div>
                                    <div class="lead">
                                        <a href="#" @click.prevent class="card-link text-white">
                                            Total
                                        </a>
                                    </div>
                                    <div class="small font-italic" v-if="totalizar(lista, 'prontos') > 0">
                                        Prontos: {{ totalizar(lista, 'prontos') }}
                                    </div>
                                    <div class="small font-italic" v-if="totalizar(lista, 'atrasados') > 0">
                                        Atrasados: {{ totalizar(lista, 'atrasados') }}
                                    </div>
                                </div>
                                <div>
                                    <div class="display-4">
                                        {{ totalizar(lista, 'qtde') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </template>
    
        </template>       

        <pre v-if="false">{{ lista }}</pre>
    </div>
</template>

<script>
import _ from 'lodash';
import * as moment from 'moment';
import SubMenuLaudos from './SubMenuLaudos.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data () {
        return {
            dados: null,
            from: moment().subtract(7, "days").format('YYYY-MM-DD'),
            to: this.$util.hoje(),
            filtro: {
                id_fila_laudo: this.$util.getCookie('laudo-fila'),
                id_status_laudo: "",
                id_unidade_operacao: this.$util.getCookie('unidade-fila-laudo'),
                id_recepcao: this.$util.getCookie('recepcao-fila-laudo'),
                id_medico: ( !this.$store.state.user.medico && this.$store.state.contexto && this.$store.state.contexto.fila_id_medico )
                    ? this.$store.state.contexto.fila_id_medico
                    : '',
                inicio: "",
                fim: "",
                periodo: "do",
                tipo_data: "",
                grupo: "", 
                id_operadora: "",  
                tipo_visao: "", 
            },
            filas: [],
            search: "",
            paciente: "",
            laudo: null,
            page: 1,
            canceltoken: null,
            tem_paginacao: false,
            search_timeout: null,
            acao_anexar: false,
            meus: false,
            firstLoad: false,
            buscar_ao_abrir: false,
            refresher: null,
            informacoes: null,
            agrupar_por_status: false, 
            tipo_visao_buscada: "", 
        }
    },

    components: { 
        SubMenuLaudos,
        AzEmptyState, 
        AzPeriodo,
        AzInput, 
    },

    computed: { 
        lista: function () {
            if ( !this.dados || !this.dados.data )
                return [];


            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados.data.filter (item => ( !this.search || reg.test(JSON.stringify(item)) ));
        },

        lista_agrupada: function () { 
            return _.groupBy(
                _.orderBy(this.lista, 'grupo_nome'), 
                'grupo_nome'
            );
        },

        lista_status_buscados: function () { 
            return _.uniqBy(this.lista, 'id_status_laudo');
        }
    },

    methods: { 
        totalizar (lista, campo) { 
            return lista.reduce((total, carry) => { 
                return total + parseFloat(carry[campo]);
            }, 0);
        },

        load() {
            this.$store.commit('setContexto', { fila_id_medico: this.filtro.id_medico })

            this.$util.setCookie('laudo-fila', this.filtro.id_fila_laudo);
            this.$util.setCookie('unidade-fila-laudo', this.filtro.id_unidade_operacao);
            this.$util.setCookie('recepcao-fila-laudo', this.filtro.id_recepcao);

            if ( this.$store.state.user.medico ) {
                this.$util.setCookie('laudo-fila-meus-' + this.$store.state.user.id_usuario, this.meus ? 'S' : 'N');
            }

            this.$util.setCookie('wl-per', this.filtro.periodo);

            // let fila = this.filas.find(item => item.id_fila_laudo == this.filtro.id_fila_laudo);

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            this.dados = null;
            this.tipo_visao_buscada = this.filtro.grupo ? this.filtro.tipo_visao : '';
            
            this.$util.load(this, {
                service: 'laudos',
                func: 'index',
                canceltoken: this.canceltoken.token,
                parms: {
                    fila: true,
                    from: this.from,
                    to: this.to,
                    ...this.filtro,
                    page: this.page,
                    size: 100,
                    search: this.search,
                    id_paciente: this.paciente ? this.paciente.id_pessoa : null,
                    meus: this.meus,
                    visao: true, 
                },
                final: () => {
                    this.firstLoad = true;

                    if ( this.dados && this.dados.last_page > 1 ) {
                        this.tem_paginacao = true;
                    }
                }
            });
        }
    },

    beforeMount() {
        this.agrupar_por_status = this.$util.getCookie('ld-aps') == 'S';

        if ( this.$store.state.user.medico ) {
            this.meus = this.$util.getCookie('laudo-fila-meus-' + this.$store.state.user.id_usuario) != 'N';
        }

        if ( this.$route.params.filtro ) {
            this.filtro = this.$route.params.filtro;
            this.buscar_ao_abrir = true;
        } else {
            this.filtro.periodo = this.$util.getCookie('wl-per') ? this.$util.getCookie('wl-per') : 'do';
        }
    },

    mounted() {

        this.$store.commit("setBreadcrumb", [
            { name: "Laudos", path: "/laudos/lista" }, 
            { name: "Visão Geral", path: "/laudos/visao" }
        ]);

        this.$util.loadItem(this, {
            service: 'fila_laudos',
            func: 'index',
            parms: {
                todas: true,
            }
        })
        .then(res => {
            this.filas = res;

            if ( this.buscar_ao_abrir )
                this.load();
        });

    },
    
}
</script>

